import React, { useState } from "react";
import "./OurTeam.css";
import teamImage from "../../../assets/thumbnails/persons_image.png"; // <-- your PNG image
import { PhoneCall, UsersRound } from "lucide-react";
import CallbackPopup from "../../../components/common/CallbackPopup";

function OurTeam() {
  const [popupOpen, setPopupOpen] = useState(false);

  //whatsapp button
  const phoneNumber = "918761005772";
  const message = "Hello! I want to know more about your services.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  return (
    <section className="ourteam-section" aria-labelledby="ourteam-title">
      <div className="ourteam-container">
        {/* Left Image */}
        <div className="ourteam-image-box">
          <img loading="lazy" decoding="async" src={teamImage} alt="Spirent India team" className="ourteam-image" />
          <div className="ourteam-team-note"><span className="ourteam-team-icon"><UsersRound size={23} aria-hidden="true" /></span><div><strong>50+ professionals</strong><span>One team. Shared expertise.</span></div></div>
        </div>

        {/* Right Text */}
        <div className="ourteam-content">
          <p className="ourteam-eyebrow">Our Team</p>
          <h2 className="ourteam-heading" id="ourteam-title">The people behind<br />every project.</h2>
          <p className="ourteam-text">
            We are a team of 50+ highly qualified professionals including civil
            & structural engineers, chartered engineers, architects, and
            management professionals. Our multi-disciplinary skills help us take
            on even the most complex designs and challenging projects.
          </p>
          <p className="ourteam-text">
            We believe consultancy is a team effort. That’s why we have strong
            groups led by capable managers who guide every stage with expertise.
          </p>
          <p className="ourteam-text">
            Our team includes committed professionals with deep experience,
            focused on delivering quality and making a real difference in every
            project.
          </p>

          <div className="ourteam-actions">
            <a className="ourteam-button ourteam-whatsapp" href={whatsappUrl}>
              <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="" width="20" height="20" />
              WhatsApp us
            </a>
            <button type="button" className="ourteam-button ourteam-callback" onClick={() => setPopupOpen(true)}>
              <PhoneCall size={18} aria-hidden="true" />Request callback
            </button>
          </div>
          <CallbackPopup open={popupOpen} setOpen={setPopupOpen} />
        </div>
      </div>
    </section>
  );
}

export default OurTeam;
